<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3"  >
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Training & Certification</a>
      </li>
      
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align: center;">
          <span class="page-sub-title">
            <ng-container>User Profile</ng-container>
          </span>
        </h3>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
          <div class="section-wrapper">
            <span class="mandatory-info pull-right">
              Fields marked with
              <span class="mandatory">*</span> are mandatory
            </span>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="sub-section-wrapper">
                <span class="section-sub-title">{{UserTypeName}} : <span> {{UserName}}</span></span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Unit : <span> {{Unit}}</span></span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">{{UserTypeIDName}} : <span> {{EmployeeId}}</span></span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Designation : <span> {{Designation}}</span></span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Reporting To : <span> {{ReportingTo}}</span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="table-responsive margin-top-15 table-view">
              <table align="center" class="table table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th style="text-align: center; width: 320px;" rowspan="2">Training Title</th>
                    <th style="text-align: center;" rowspan="2">Certificate Date</th>
                    <th style="text-align: center;" rowspan="2">Expiry Date</th>
                    <th style="text-align: center;" rowspan="2">Status</th>
                    <th style="text-align: center;" rowspan="2">Preview Certificate</th>
                    <th style="text-align: center;" rowspan="2">Download Training / Course PDF</th>
                    <!-- <th style="text-align: center;" rowspan="2">Send Reminder</th> -->
                  </tr>
                </thead>
                <tr class="title-user-profile">
                  <td colspan="7">Mandatory</td>
                </tr>
                <tbody *ngIf="tncManditoryRecords[0]">
                  <tr style="text-align: center; cursor:pointer;"
                    (contextmenu)="cm.show($event);showContextMenu(tncRecord)" #row
                    *ngFor='let tncRecord of tncManditoryRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.ParticularName}}
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <span *ngIf="tncRecord.CertificationDate">{{tncRecord.CertificationDate | dateTimeFormat: "MMM D,
                        YYYY"}}</span>
                      <span *ngIf="!tncRecord.CertificationDate">NA</span>
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <p style="padding-top: 10px;"
                        *ngIf="tncRecord.StatusName == 'Complete' && tncRecord.CertificationDate && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate =='Lifetime'">
                        {{tncRecord.CertificateExpiryDate}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="(tncRecord.StatusName == 'Complete' || tncRecord.StatusName == 'Expired') && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate !='Lifetime'">
                        {{tncRecord.CertificateExpiryDate | dateTimeFormat: "MMM D, YYYY"}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="!tncRecord.CertificateExpiryDate || (tncRecord.StatusName != 'Complete' && tncRecord.StatusName !== 'Expired') ">
                        NA
                      </p>
                    </td>
                   
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.StatusName}}
                    </td>
                    <td>
                      <div *ngIf="tncRecord.Certificate && tncRecord.Certificate.length > 0">
                        <ara-files-previewer [files]="tncRecord.Certificate"></ara-files-previewer>
                      </div>
                    </td>
                    
                    <td style="text-align: center;">
                      <i (click)="downloadPDF(tncRecord.CourseId)" class="pi pi-file-pdf" style="font-size: 2rem;"></i>
                    </td>
                    <!-- <td style="text-align: center;">
                      <input
                      type="checkbox"
                      [checked]="tncRecord.ReminderNotification"
                      (click)="updateReminderNotification(tncRecord,$event.target.checked)"
                      [(ngModel)]="tncRecord.ReminderNotification"
                      [value]="tncRecord.ReminderNotification"
                    />
                    </td> -->
                  </tr>
                </tbody>
                <br>
                <tr class="title-user-profile">
                  <td colspan="7">Job Related</td>
                </tr>
                <tbody *ngIf="tncJobRelatedRecords[0]">
                  <tr style="text-align: center; cursor:pointer;"
                    (contextmenu)="cm.show($event);showContextMenu(tncRecord)" #row
                    *ngFor='let tncRecord of tncJobRelatedRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.ParticularName}}
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <span *ngIf="tncRecord.CertificationDate">{{tncRecord.CertificationDate | dateTimeFormat: "MMM D,
                        YYYY"}}</span>
                      <span *ngIf="!tncRecord.CertificationDate">NA</span>
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <p style="padding-top: 10px;"
                        *ngIf="tncRecord.StatusName == 'Complete' && tncRecord.CertificationDate && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate =='Lifetime'">
                        {{tncRecord.CertificateExpiryDate}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="(tncRecord.StatusName == 'Complete' || tncRecord.StatusName == 'Expired') && tncRecord.CertificationDate && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate !='Lifetime'">
                        {{tncRecord.CertificateExpiryDate | dateTimeFormat: "MMM D, YYYY"}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="!tncRecord.CertificateExpiryDate || (tncRecord.StatusName != 'Complete' && tncRecord.StatusName !== 'Expired') ">
                        NA
                      </p>
                    </td>
                  
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.StatusName}}
                    </td>
                    <td>
                      <div *ngIf="tncRecord.Certificate && tncRecord.Certificate.length > 0">
                        <ara-files-previewer [files]="tncRecord.Certificate"></ara-files-previewer>
                      </div>
                    </td>
                    <td style="text-align: center;">
                      <i (click)="downloadPDF(tncRecord.CourseId)" class="pi pi-file-pdf" style="font-size: 2rem;"></i>
                    </td>
                    <td style="text-align: center;">
                      <input
                      type="checkbox"
                      [checked]="tncRecord.ReminderNotification"
                      (click)="updateReminderNotification(tncRecord,$event.target.checked)"
                      [(ngModel)]="tncRecord.ReminderNotification"
                      [value]="tncRecord.ReminderNotification"
                    />
                    </td>
                  </tr>
                </tbody>
                <br>
                <tr class="title-user-profile">
                  <td colspan="7">Additional</td>
                </tr>
                <tbody *ngIf="tncAdditionalRecords[0]">
                  <tr style="text-align: center; cursor:pointer;"
                    (contextmenu)="cm.show($event);showContextMenu(tncRecord)" #row
                    *ngFor='let tncRecord of tncAdditionalRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.ParticularName}}
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <span *ngIf="tncRecord.CertificationDate">{{tncRecord.CertificationDate | dateTimeFormat: "MMM D,
                        YYYY"}}</span>
                      <span *ngIf="!tncRecord.CertificationDate">NA</span>
                    </td>
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      <p style="padding-top: 10px;"
                        *ngIf="tncRecord.StatusName == 'Complete' && tncRecord.CertificationDate && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate =='Lifetime'">
                        {{tncRecord.CertificateExpiryDate}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="(tncRecord.StatusName == 'Complete' || tncRecord.StatusName == 'Expired') && tncRecord.CertificateExpiryDate && tncRecord.CertificateExpiryDate !='Lifetime'">
                        {{tncRecord.CertificateExpiryDate | dateTimeFormat: "MMM D, YYYY"}}
                      </p>
                      <p style="padding-top: 10px;"
                        *ngIf="!tncRecord.CertificateExpiryDate || (tncRecord.StatusName != 'Complete' && tncRecord.StatusName !== 'Expired') ">
                        NA
                      </p>
                    </td>
                    
                    <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                      [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                      {{tncRecord.StatusName}}
                    </td>
                    <td>
                      <div *ngIf="tncRecord.Certificate && tncRecord.Certificate.length > 0">
                        <ara-files-previewer [files]="tncRecord.Certificate"></ara-files-previewer>
                      </div>
                    </td>
                    <td style="text-align: center;">
                      <i (click)="downloadPDF(tncRecord.CourseId)" class="pi pi-file-pdf" style="font-size: 2rem;"></i>
                    </td>
                    <td style="text-align: center;">
                      <input
                      type="checkbox"
                      [checked]="tncRecord.ReminderNotification"
                      (click)="updateReminderNotification(tncRecord,$event.target.checked)"
                      [(ngModel)]="tncRecord.ReminderNotification"
                      [value]="tncRecord.ReminderNotification"
                    />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pull-right">
                <br>
                <button type="button" class="btn btn-primary primary-btn button-download-user-profile" (click)="downloadUserProfilePDF()">
                  <i class="fa fa-download"></i> Download User Profile
                </button>

              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>
<p-contextMenu [appendTo]="row" [target]="row" #cm [model]="contextItems"></p-contextMenu>
